function getQueryVariable(variable)
{
    if (!location.hash) return(false);

    var query = location.hash.split("?")[1];
    if (!query) return(false);

    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

window.siteId = process.env.SITE_ID;

export default function(Vue){
    Vue.conf = {
        apiHost: 'https://crm.mmngr.com',
        siteId: window.siteId
    }

    Object.defineProperties(Vue.prototype,{
        $conf: {
            get:() => {
                return Vue.conf
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/config.js